<template>
    <b-row v-if="!items">
        <b-col cols="12" md="4">
            <b-skeleton width="100%" height="85px" animation="throb"></b-skeleton>
        </b-col>
        <b-col cols="12" md="4">
            <b-skeleton width="100%" height="85px" animation="throb"></b-skeleton>
        </b-col>
    </b-row>
    <b-row v-else>
            <b-col cols="12" class="mb-4"><b-button variant="success" @click="$router.push(`/admin/spark/create`)">{{ $t('add') }}</b-button></b-col>
            <b-col cols="12" md="4" v-for="item in items" :key="item.uuid">
                <b-card class="spark" @click="$router.push(`/admin/spark/${item.uuid}`)">
                    <b-card-header>{{ item.name }}</b-card-header> 

                    <br />
                    <b-icon icon="wrench"></b-icon> <small> {{ item.dev_version || "not active" }}</small>
                    <br />
                    <b-icon icon="people"></b-icon>  <small> {{ item.public_version || "not live" }}</small>
                </b-card>
            </b-col>
        <span v-if="items.length < 1">{{ $t('noSparks') }} </span>
    </b-row>
</template>
<script>
export default {
    name: 'List',
    components: { },
    data: function() {
        return {
            items: null
        }
    },
    methods: {},
    mounted() {
       if (!this.$isAdmin()) {
            return this.$router.back();
       }

       this.$sandbox.spark().all().then(resp => {
            this.items = resp.data
       }).catch(err => {
           this.$debugLog(err)
           this.$pageUnavailable()
       })
    }
}
</script>

<style scoped>
.spark {
    cursor: pointer;
}
</style>
